/**
 * 丰田车辆的导入导出
 */
export const exportToyotaBuyInUrl = '/toyota/buyIn/export'
export const exportToyotaSellOutUrl = '/toyota/sellOut/export'
export const importToyotaBuyInUrl = process.env.VUE_APP_BASEURL + '/toyota/buyIn/import'
export const importToyotaSellOutUrl = process.env.VUE_APP_BASEURL + '/toyota/sellOut/import'
